import apiClient from "./client";

export const getAdminCallRequestServices = async () => {
  const response = await apiClient.get("/call-request-services/admin");
  return response.data;
};

export const createAdminCallRequestService = async (payload) => {
  const response = await apiClient.post("/call-request-services/admin", payload);
  return response.data;
};

export const updateAdminCallRequestService = async ({ id, payload }) => {
  const response = await apiClient.put(`/call-request-services/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminCallRequestService = async ({ id }) => {
  await apiClient.delete(`/call-request-services/admin/${id}`);
};

export const getAdminCallRequests = async ({ status } = {}) => {
  const response = await apiClient.get("/call-requests/admin", {
    params: status ? { status } : {},
  });
  return response.data;
};

export const updateAdminCallRequestStatus = async ({ id, status }) => {
  const response = await apiClient.put(`/call-requests/admin/${id}/status`, { status });
  return response.data;
};

export const deleteAdminCallRequest = async ({ id }) => {
  await apiClient.delete(`/call-requests/admin/${id}`);
};
